import { UseFormSetValue, UseFormWatch } from "react-hook-form";

import { ERROR_TYPE, translateError } from "@/utils";

import IndustrySelectorItem from "./IndustrySelectorItem";

interface IndustrySelectorFactoryProps {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	setValue: UseFormSetValue<any>;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	watch: UseFormWatch<any>;
	industries: { id: number; name: string }[];
	error?: string;
	containerClassName?: string;
}

export default function IndustrySelectorFactory({
	setValue,
	watch,
	industries,
	error,
	containerClassName = "",
}: IndustrySelectorFactoryProps) {
	const selectedIndustries = watch("industryIds");

	return (
		<div className={`space-y-1 mb-4 w-full relative ${containerClassName}`}>
			<IndustrySelectorItem
				error={error}
				industries={industries}
				name="industryIds"
				setValue={setValue}
				value={selectedIndustries}
			/>
			{error && (
				<p className="absolute -bottom-5 text-[12px] text-[#FF1034]">
					{translateError[error as ERROR_TYPE] ?? error}
				</p>
			)}
		</div>
	);
}
